import { SET_LANGUAGE } from 'constants/ActionTypes';
import { custom } from 'utils/Api';

export const defaultLanguage = 'is';

export const setLanguage = (language = defaultLanguage) => {
  localStorage.language = language;
  return {
    type: SET_LANGUAGE,
    language,
  };
};

export const requestLanguage = language =>
  (dispatch, getState) => {
    const { token } = getState().loginReducer.user;

    const config = {
      url: 'api/language/change',
      method: 'POST',
      headers: { Authorization: `Bearer ${token}` },
      data: JSON.stringify(language === 'en' ? 'en-US' : 'is-IS'),
    };
    custom(config)
      .then(() => {
        dispatch(setLanguage(language));
        window.location.reload();
      })
      .catch(() => {
        dispatch(setLanguage());
        window.location.reload();
      });
  };



// WEBPACK FOOTER //
// ./src/actions/language.js